module.exports = __webpack_public_path__ + "media/images/new_landing/hp/tile-4-008a222d6c9c76f1ae89163f415ef7be.jpg";